module.exports = __webpack_public_path__ + "img/page-header-close-sheet.16e41ecf.svg";